import { isFunction } from "lodash";
import React from "react";
import { StyledInput } from "./input.styles";

export const CustomisableStyledInput = React.forwardRef((props, ref) => {
  const { inputRender, ...otherProps } = props;

  if (isFunction(inputRender)) {
    return (
      <>
        {inputRender({ ...otherProps, ref })}
      </>
    );
  }

  return <StyledInput {...otherProps} ref={ref} />
});